import { Card, Typography } from '@mui/material';
import { SVButton, SVLoader } from '../core';
import { ROUTES } from '@/constants/routes';
import { useGetTransactionList } from '@/hooks/requests/useTransactions';
import { TransactionStatusCategory } from '@/types/transactions';
import TransactionTable from '../transactions/TransactionTable';
import { useNavigate } from 'react-router-dom';

type BankAccountDetailsTransactionsProps = {
  bankAccountId: string;
};

export default function BankAccountDetailsTransactions({
  bankAccountId,
}: BankAccountDetailsTransactionsProps) {
  const navigate = useNavigate();
  const {
    transactionList: processedTransctionList,
    isTransactionListPending: isProcessedTransactionListPending,
  } = useGetTransactionList(bankAccountId, {
    page: 0,
    records_per_page: 3,
    status: TransactionStatusCategory.PROCESSED,
  });
  const { transactionList: pendingTransctionList } = useGetTransactionList(
    bankAccountId,
    {
      page: 0,
      records_per_page: 3,
      status: TransactionStatusCategory.PENDING,
    },
  );

  return (
    <>
      {pendingTransctionList.length ? (
        <Card>
          <Typography variant="h5">Pending Transactions</Typography>
          <TransactionTable
            transactionList={pendingTransctionList}
            bankAccountId={bankAccountId}
          />
          <SVButton
            variant="text"
            onClick={() =>
              navigate(`${ROUTES.BANK_ACCOUNTS}/${bankAccountId}/transactions`)
            }>
            View More
          </SVButton>
        </Card>
      ) : null}
      <Card>
        {isProcessedTransactionListPending ? (
          <SVLoader />
        ) : (
          <>
            <Typography variant="h5">Recent Transactions</Typography>
            <TransactionTable
              transactionList={processedTransctionList}
              bankAccountId={bankAccountId}
              emptyTableContent="No recent transactions have been made"
            />
          </>
        )}
        <SVButton
          data-testid="view-more-button"
          variant="text"
          onClick={() =>
            navigate(`${ROUTES.BANK_ACCOUNTS}/${bankAccountId}/transactions`)
          }>
          View More
        </SVButton>
      </Card>
    </>
  );
}
